import datepicker from 'bootstrap-datepicker';

$('.datepicker-start-today').datepicker({
    format: 'dd/mm/yyyy',
    startDate: new Date(),
    autoclose: true,
    calendarWeeks: true,
    weekStart: 1,
});
